var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTron = function SvgTron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.796,
    cy: 12.335,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.705 7.558 5.796 5.335l6.267 16 8.733-10.794-3.09-2.983Zm-.191.98 1.821 1.757-4.982.915 3.16-2.672Zm-9.495-1.93 5.252 4.42 3.331-2.817L8.02 6.608Zm4.877 5.2-.856 7.183L7.423 7.203l5.473 4.606Zm6.31-.632L13.69 12.19l-.811 6.809 6.328-7.823Z",
    fill: "#000"
  })));
};

export default SvgTron;